/**
 * When a favorites list has both a base product entry and variant entries for
 * the same product, only keep the variant entries.
 */
export function deduplicateFavoriteProducts(products) {
  const baseArticleNumbersWithVariants = new Set(
    products
      .filter(product => product.isVariant)
      .map(product => product.articleNumber)
  );

  return products.filter(product => {
    if (!product.hasVariants || product.isVariant) {
      return true;
    }

    return !baseArticleNumbersWithVariants.has(product.articleNumber);
  });
}

export function getItemsForAddToCart(products) {
  return deduplicateFavoriteProducts(products)
    .filter(product => product.validation.status === 'valid')
    .map(product => ({
      ...product,
      articleNumber: product.isVariant
        ? product?.variant?.articleNumber
        : product?.articleNumber,
      quantity: product?.quantity || 1
    }));
}
